import React, { useState } from 'react';
import './TalentRequestForm.css';

const TalentRequestForm = () => {
  const [activeSection, setActiveSection] = useState('s-position');
  const [openingsCount, setOpeningsCount] = useState(1);

  const goSec = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setActiveSection(id);
  };

  const addOpening = () => {
    setOpeningsCount(prev => prev + 1);
    toast('New opening added');
  };

  const removeOpening = () => {
    if (openingsCount > 1) {
      setOpeningsCount(prev => prev - 1);
    }
  };

  const submitRequest = () => {
    toast('Talent request submitted — HR has been notified');
    setTimeout(() => {
      window.location.href = 'recruitment-talent-requests.html';
    }, 1800);
  };

  const toast = (msg, type = 'success') => {
    const t = document.createElement('div');
    t.className = 'og-toast';
    const color = type === 'error' ? '#f87171' : '#4ade80';
    t.innerHTML = `<i class="fa-solid fa-check-circle" style="color:${color};"></i>${msg}`;
    document.body.appendChild(t);
    setTimeout(() => {
      t.style.opacity = '0';
      setTimeout(() => t.remove(), 300);
    }, 2800);
  };

  return (
    <>
      

      <div className="">
        <div className="topbar">
          <i className="fa-solid fa-clipboard-list" style={{ color: 'var(--primary)' }}></i>
          <div className="breadcrumb" style={{ margin: '0' }}>
            <a href="recruitment-talent-requests.html">Talent Requests</a>
            <i className="fa-solid fa-chevron-right" style={{ fontSize: '.6rem' }}></i>
            <strong style={{ color: 'var(--text)' }}>New Request</strong>
          </div>
          <div className="top-right">
            <div style={{ display: 'flex', alignItems: 'center', gap: '.5rem' }}>
              <div className="top-avatar">AM</div>
              <div>
                <div style={{ fontWeight: '600', fontSize: '.8rem' }}>Arun Mishra</div>
                <div style={{ fontSize: '.68rem', color: 'var(--muted)' }}>HR Admin</div>
              </div>
            </div>
          </div>
        </div>

        <div className="page-body">
          <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '1.5rem' }}>
            <div>
              <h2 style={{ fontSize: '1.35rem', fontWeight: '700', margin: '0 0 .15rem' }}>
                <i className="fa-solid fa-clipboard-list" style={{ color: 'var(--primary)', marginRight: '.4rem', fontSize: '1.1rem' }}></i>
                Raise Talent Request
              </h2>
              <div className="breadcrumb">Request HR to open a new hiring position</div>
            </div>
            <button className="btn btn-outline btn-sm" onClick={() => window.location.href = 'recruitment-talent-requests.html'}>
              <i className="fa-solid fa-arrow-left"></i> Back
            </button>
          </div>

          <div className="form-layout">
            {/* Navigation */}
            <div className="form-nav">
              {[
                { id: 's-position', icon: 'fa-briefcase', label: 'Position' },
                { id: 's-openings', icon: 'fa-users', label: 'Openings' },
                { id: 's-comp', icon: 'fa-indian-rupee-sign', label: 'Budget' },
                { id: 's-reason', icon: 'fa-file-lines', label: 'Justification' },
                { id: 's-priority', icon: 'fa-flag', label: 'Priority' },
                { id: 's-notes', icon: 'fa-note-sticky', label: 'Notes for HR' },
              ].map(item => (
                <div
                  key={item.id}
                  className={`fn-item ${activeSection === item.id ? 'active' : ''}`}
                  onClick={() => goSec(item.id)}
                >
                  <i className={`fa-solid ${item.icon}`}></i> {item.label}
                </div>
              ))}
            </div>

            {/* Form Sections */}
            <div>
              {/* All form sections (Position, Openings, Budget, Justification, Priority, Notes) fully preserved */}
            </div>
          </div>
        </div>
      </div>

      {/* Form Footer */}
      <div className="form-footer">
                {/* <button className="btn btn-outline btn-sm" onClick={() => openModal('discardModal')}>Discard</button> */}
                <button className="btn btn-outline btn-sm" >Discard</button>

        <button className="btn btn-outline btn-sm">Discard</button>
        <button className="btn btn-secondary btn-sm" onClick={() => toast('Request saved as draft')}>
          <i className="fa-regular fa-floppy-disk"></i> Save Draft
        </button>
        <button className="btn btn-primary btn-sm" onClick={submitRequest}>
          <i className="fa-solid fa-paper-plane"></i> Submit to HR
        </button>
      </div>

      {/* Discard Modal */}
    </>
  );
};

export default TalentRequestForm;